// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button.event-menu {\n  width: 50px;\n  min-width: 50px;\n  height: 50px;\n}\nbutton.event-menu:hover {\n  border-color: #22A588;\n}", ""]);
// Exports
module.exports = exports;
